import { createStore } from 'vuex';

import positionInquiryMail from './positionInquiryMail';
import requestParam from './requestParam';
import oneClickInquiry from './oneClickInquiry';

// TODO: このvuex stateを廃止し、app/javascript/javascripts/slide_form_common_moduleに移し替える
export default createStore({
  modules: {
    positionInquiryMail,
    requestParam,
    oneClickInquiry
  }
});